import React from 'react'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LoanListNav2UI from '../../../components/superUser/loanList/LoanListNav2UI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import LoanListSF from '../../../components/superUser/loanList/LoanListSF'

const LoanListPageUI = ({ context, errorList, loanList, response, onRefreshClick, onTypeChange, openOrClosed, pageTitle, fundSourceList }) =>
  <SuperUserHomePageUI context={context} className='pg_su_loan_a_lst' topnav='loans'
    centered={!loanList && !errorList} page='loans' dimension='w768' onTypeChange={onTypeChange}
  >
    {
      !loanList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loanList &&
      <div>
        {
          loanList.length !== 0 &&
          <LoanListSF context={context} loanList={loanList} fundSourceList={fundSourceList} pageTitle={pageTitle}
            onRefreshClick={onRefreshClick} openOrClosed={openOrClosed} response={response}
          />
        }
        {
          loanList.length === 0 &&
          <div className='g_m_top_50'>
            <span className='g_flex_h g_flex_left'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>{pageTitle}</b></span>
            </span>
            <LoanListNav2UI page={openOrClosed} />
            <EmptyListUI className='g_m_top_200'
              context={context}
              createEnabled={false}
              createDisabledMessageLabel='No loans yet'
            />
          </div>
        }
      </div>
    }
  </SuperUserHomePageUI>

export default LoanListPageUI
